import * as React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core';
import { useStyles } from '../../../custom-forms';
import { CustomIcon } from '../../../custom-forms';
import { useTranslate } from '../../../hooks/useTranslate';
import { useAppSelector } from '../../../store/configureStore';

export interface AlternativeCalculationHeaderProps {
  onClose: () => void;
  title: string;
  showReference: boolean;
}

const AlternativeCalculationHeader: React.FC<AlternativeCalculationHeaderProps> = ({
  onClose,
  title,
  showReference
}) => {
  const c = useStyles();
  const t = useTranslate();
  const caseSettingsState = useAppSelector((s) => s.caseSettings);
  const reference = `${t('CASES_CASE_TAB', 'Dosar')} #${caseSettingsState?.case?.id ?? ''}`;
  const stateLabel = caseSettingsState?.case?.caseStatus?.caseStatus?.displayName ?? '';
  return (
    <Box className={c.titleBar}>
      <Typography variant="h6" className={c.titleBarTitle}>
        {title}
      </Typography>
      {showReference && (
        <Typography variant="subtitle2" className={c.titleBarSubtitle}>
          {reference} · {stateLabel}
        </Typography>
      )}
      <Tooltip
        title={t('ALT_CALC_CLOSE_NO_SAVE', 'Închide fără să salvezi')}
        placement="bottom-end"
      >
        <IconButton className={c.titleBarClose} onClick={onClose} aria-label="close">
          <CustomIcon name="x" size={20} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default AlternativeCalculationHeader;
